import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formaterer tall med mellomrom for hvert tusen
 * F.eks. 1000000 -> 1 000 000
 */
export const formatNumberWithSpaces = (value: string | number): string => {
  if (!value && value !== 0) return '';
  
  // Fjern eksisterende mellomrom og konverter til string
  const plainValue = String(value).replace(/\s/g, '');
  
  // Del opp i heltall og desimal hvis det finnes
  const parts = plainValue.split('.');
  const integerPart = parts[0];
  
  // Formater heltallsdelen med mellomrom per tusen
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  // Sett sammen igjen med desimaldel hvis det fantes
  return parts.length > 1 ? `${formattedInteger}.${parts[1]}` : formattedInteger;
};

/**
 * Fjerner mellomrom fra en tallstreng
 * F.eks. "1 000 000" -> "1000000"
 */
export const removeSpaces = (value: string): string => {
  return value.replace(/\s/g, '');
};
